import Navbar from "../../components/general/Navbar";
import BuyerCart from "../../components/buyers/BuyerCart";
import Footer from "../../components/general/Footer";

export default function BuyerCartPage() {
  return (
    <>
      <Navbar />
      <BuyerCart />
      <Footer />
    </>
  )
}

